import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=aaecc442&scoped=true"
import script from "./Space.vue?vue&type=script&lang=js"
export * from "./Space.vue?vue&type=script&lang=js"
import style0 from "./Space.vue?vue&type=style&index=0&id=aaecc442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaecc442",
  null
  
)

export default component.exports